const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error("REACT_APP_API_BASE_URL n'est pas défini !");
  throw new Error("REACT_APP_API_BASE_URL n'est pas défini dans l'environnement.");
}

console.log("API_BASE_URL utilisée :", API_BASE_URL);

export default API_BASE_URL;
